
// @ts-nocheck
import locale__app_template1_locales_en_json from "../locales/en.json";
import locale__app_template1_locales_fr_json from "../locales/fr.json";
import locale__app_template1_locales_de_json from "../locales/de.json";
import locale__app_template1_locales_zh_json from "../locales/zh.json";


export const localeCodes =  [
  "en",
  "fr",
  "de",
  "zh"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__app_template1_locales_en_json), cache: true }],
  "fr": [{ key: "../locales/fr.json", load: () => Promise.resolve(locale__app_template1_locales_fr_json), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__app_template1_locales_de_json), cache: true }],
  "zh": [{ key: "../locales/zh.json", load: () => Promise.resolve(locale__app_template1_locales_zh_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "dir": "ltr",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "fr",
      "iso": "fr-FR",
      "name": "French",
      "dir": "ltr",
      "files": [
        "locales/fr.json"
      ]
    },
    {
      "code": "de",
      "iso": "de-DE",
      "name": "German",
      "dir": "ltr",
      "files": [
        "locales/de.json"
      ]
    },
    {
      "code": "zh",
      "iso": "zh-CN",
      "name": "Chinese",
      "dir": "ltr",
      "files": [
        "locales/zh.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en-US",
    "name": "English",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "fr",
    "iso": "fr-FR",
    "name": "French",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/fr.json"
      }
    ]
  },
  {
    "code": "de",
    "iso": "de-DE",
    "name": "German",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/de.json"
      }
    ]
  },
  {
    "code": "zh",
    "iso": "zh-CN",
    "name": "Chinese",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/zh.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
